/** UUID v4 generation (Web Crypto, works in browsers, workers and Node 19+). */
export function uuid(): string {
  return crypto.randomUUID();
}

export function isUuid(v: unknown): v is string {
  return typeof v === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);
}
